import React from 'react'
import { MultiSelectWithModal } from 'components'
import { useGetSku } from 'hooks'
import { reportingPeriodCheck, stripDuplicates } from 'utils/utilities'

type SelectSkuProps = {
  skuState: {
    sku: string[]
    skuName: string[]
    division?: string[]
    category?: string[]
    subCategory?: string[]
    brand?: string[]
    reportingPeriod?: string
    startDate?: string
    endDate?: string
    reportName?: string
  }
  onChange(
    data: {
      division: string[]
      category: string[]
      subCategory: string[]
      brand: string[]
      sku: string[]
      skuName: string[]
    },
    isDefaultAll?: boolean
  ): void
  buttonBelow?: boolean
  disabled?: boolean
}

export const SelectSku = (props: SelectSkuProps) => {
  const { skuState, onChange, buttonBelow, disabled } = props
  const {
    sku,
    skuName,
    division = ['all'],
    category = ['all'],
    subCategory = ['all'],
    brand = ['all'],
    reportingPeriod,
    startDate,
    endDate,
    reportName,
  } = skuState

  const { getSkuStatus, getIsSkuLoading, skuData, getSkuError } = useGetSku({
    division,
    category,
    subCategory,
    brand,
    reportingPeriod,
    startDate,
    endDate,
    reportName,
  })

  const isEnabled =
    !disabled &&
    !!division.length &&
    !!category.length &&
    !!subCategory.length &&
    !!brand.length &&
    reportingPeriodCheck(reportingPeriod, startDate, endDate)

  const [fieldError, setFieldError] = React.useState('')
  const validateField = (setValidation: boolean = false) => {
    if (isEnabled) {
      if (getSkuStatus === 'error') {
        return getSkuError?.errorMessage ?? 'Network Error!'
      }
      if (!sku.length) {
        if (fieldError) return true
        else if (setValidation) setFieldError('triggered')
      }
    }
    return ''
  }
  const getErrorText = () => {
    const value = validateField()
    if (typeof value === 'string') return value
    return ''
  }

  const onSkuSelected = (sku: string[], skuName: string[], isDefaultAll?: boolean) => {
    const filterData =
      !!skuData && !sku.includes('all') ? skuData.filter((item) => sku.includes(item.sku_item_number)) : []

    onChange(
      {
        division: stripDuplicates(filterData.map((item) => item.commercial_division)),
        category: stripDuplicates(filterData.map((item) => item.commercial_category)),
        subCategory: stripDuplicates(filterData.map((item) => item.commercial_class)),
        brand: stripDuplicates(filterData.map((item) => item.brand_name)),
        sku: sku,
        skuName: skuName,
      },
      isDefaultAll
    )
  }

  return (
    <MultiSelectWithModal
      id="select-sku"
      placeholder="Select SKU"
      label="SKU *"
      buttonText="Choose SKU"
      modalTitle="Select SKU"
      disabled={!isEnabled}
      isLoading={getIsSkuLoading}
      buttonBelow={buttonBelow}
      value={{ value: sku, text: skuName }}
      onChange={onSkuSelected}
      options={(skuData || []).map((item) => ({
        value: item.sku_item_number,
        text: `${item.sku_item_number} - ${item.sku_item_name}`,
      }))}
      error={!!validateField()}
      helperText={getErrorText()}
    />
  )
}
